import { connect } from 'react-redux';
import VerificationPopup from '../components/VerificationPopup';
import { isEmailVerified, getEmail } from '../selectors/user';
import { isPageLoading } from '../selectors/ui';
import { resendEmailVerification, resetEmailVerification } from '../actions/user';
import { showVerificationModal } from '../actions/ui';

const mapStateToProps = state => ({
    isLogged: state.user.isLogged,
    email: getEmail(state),
    isVerified: isEmailVerified(state),
    isResendVerificationPending: state.ui.isResendVerificationPending,
    isResendVerificationeError: state.ui.isResendVerificationeError,
    isResendVerificationSuccess: state.ui.isResendVerificationSuccess,
    isVerificationPopupFocused: state.ui.isVerificationPopupFocused,
    isPageLoading: isPageLoading(state),
});

export default connect(mapStateToProps, {
    resendEmailVerification,
    resetEmailVerification,
    showVerificationModal,
})(VerificationPopup);
